import { render } from "./BulkCampaignsList.vue?vue&type=template&id=cf3c8348&scoped=true"
import script from "./BulkCampaignsList.vue?vue&type=script&lang=ts"
export * from "./BulkCampaignsList.vue?vue&type=script&lang=ts"

import "./BulkCampaignsList.vue?vue&type=style&index=0&id=cf3c8348&scoped=true&lang=scss"
import "./BulkCampaignsList.vue?vue&type=style&index=1&id=cf3c8348&lang=scss"
script.render = render
script.__scopeId = "data-v-cf3c8348"

export default script